import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const sendMediasToQualify = async ({ filePaths, tags }) => {
  const payload = { files: filePaths };
  if (Array.isArray(tags) && tags.length > 0) {
    payload.tags = tags;
  }
  const response = await axiosInstance.post('/media_library/upload/', payload);
  return response.data;
};

export const useSendMediasToQualify = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: sendMediasToQualify,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['media-folders'] });

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    sendMediasToQualify: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
